module.exports = __webpack_public_path__ + "static/luth-logo-cecc8a4c80312586cc537f7680a2e924.png";